/*
 * The server's permission matrix, for hiding what the server would refuse.
 *
 * permissions.json is GENERATED from mushroom-bank/lambda/permissions.py, and
 * test_permissions.py fails when they differ -- so the UI and the server
 * cannot drift apart. This only decides what to show. The Lambda routes still
 * check every request.
 */
import data from './permissions.json';

export function can(user, scope) {
  return (user?.roles || []).some((role) => rolesWith(scope).includes(role));
}

/** Whether every role held is an outsider's (permissions.OUTSIDER_ROLES: a
 *  public account, an external researcher) -- or none is held. */
/** A public-only account: the survey's, and since public portal 2a Field
 *  Mode's in Observation mode. The server refuses it the map
 *  (routes/map_points.py) and every staff page. */
export function isPublicOnly(user) {
  const roles = user?.roles || [];
  return roles.length > 0 && roles.every(role => role === 'public');
}

export function isOutsider(user) {
  return (user?.roles || []).every((role) => data.outsiders.includes(role));
}

/** The roles holding `scope`, for code that still names a role list. */
export function rolesWith(scope) {
  const allowed = data.matrix[scope];
  // A typo must fail in a test, not quietly hide a page from everybody.
  if (!allowed) throw new Error(`unknown permission scope: ${scope}`);
  return allowed;
}
